import { X, FileDown, FileSpreadsheet } from 'lucide-react';

interface ForecastExportModalProps {
  isOpen: boolean;
  onClose: () => void;
  onExportPDF: () => void;
  onExportExcel: () => void;
  scenarioName: string;
}

export default function ForecastExportModal({
  isOpen,
  onClose,
  onExportPDF,
  onExportExcel,
  scenarioName
}: ForecastExportModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900">Exporter le previsionnel</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500 transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        <div className="p-6">
          <p className="text-sm text-gray-600 mb-6">
            Choisissez le format d'export pour le scenario <span className="font-semibold">{scenarioName}</span>
          </p>

          <div className="space-y-3">
            <button
              onClick={() => {
                onExportPDF();
                onClose();
              }}
              className="w-full flex items-center gap-3 px-4 py-4 bg-white border-2 border-gray-300 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-all group"
            >
              <div className="flex-shrink-0 w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center group-hover:bg-red-200 transition-colors">
                <FileDown className="text-red-600" size={24} />
              </div>
              <div className="flex-1 text-left">
                <div className="font-semibold text-gray-900">Export PDF</div>
                <div className="text-sm text-gray-500">Document formaté avec tableaux et KPIs</div>
              </div>
            </button>

            <button
              onClick={() => {
                onExportExcel();
                onClose();
              }}
              className="w-full flex items-center gap-3 px-4 py-4 bg-white border-2 border-gray-300 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-all group"
            >
              <div className="flex-shrink-0 w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center group-hover:bg-green-200 transition-colors">
                <FileSpreadsheet className="text-green-600" size={24} />
              </div>
              <div className="flex-1 text-left">
                <div className="font-semibold text-gray-900">Export Excel</div>
                <div className="text-sm text-gray-500">Fichier CSV pour tableur</div>
              </div>
            </button>
          </div>
        </div>

        <div className="px-6 py-4 bg-gray-50 rounded-b-lg">
          <button
            onClick={onClose}
            className="w-full px-4 py-2 text-sm text-gray-700 hover:text-gray-900 transition-colors"
          >
            Annuler
          </button>
        </div>
      </div>
    </div>
  );
}
